import { instance } from "api/core";
import { CallbackObject } from "api/core/get-page-function";


export const disableReplenishmentThreshold = async (warehouseId: string, locationId: string, productId: string, callback: CallbackObject<void>) => {
    const config: Record<string, any> = {
        headers: { 'Content-Type': 'application/json' },
        params: { locationId, productId },
    };

    try {
        await instance.delete(`/replenishment/warehouses/${warehouseId}/thresholds`, config);
        callback.success();
    } catch (err) {
        if (callback.error) callback.error(err);
    }
};
